module.exports = __webpack_public_path__ + "img/Cameroon.381ce827.svg";